var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getTableConfig } from "../../../../admin-columns/src/js/table/utils/global";
import axios from "axios";
export const calculateColumn = (columnName, metric) => __awaiter(void 0, void 0, void 0, function* () {
    return axios.get(window.location.href, {
        params: {
            acp_metric_nonce: getTableConfig().ajax_nonce,
            acp_metric_action: 'acp_metric_get',
            acp_metric_column: columnName,
            acp_metric_output: metric,
        },
    });
});
